import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class King extends PositionedGoodyHOC {
	// 8
	render() {
		const style = {
			st36: {
				fill: '#987FEF',
			},
			st72: {
				fill: '#FFEAAE',
			},
			st2: {
				fill: '#FFFFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.8059692" cy="53.3483009" />
				<path style={style.st36} d="M51.7131348,41.039669c-0.2718239-10.3747768,18.621727-27.5412445-18.7377701-27.5412445h0.0492706
					c-37.3594971,0-18.4659462,17.1664677-18.7377701,27.5412445H51.7131348z" />
				<path style={style.st72} d="M60.6269531,39.251194l-5.8085938-1.5058594l4.8359375-18.6577148
					c0.7763672-2.9946289-0.7958984-5.2519541-1.8027344-6.3305674c-2.7021484-2.8959961-7.3583984-4.2260742-11.8574219-3.3881836
					L33,11.789279L20.0058594,9.3688688c-4.4970703-0.8359375-9.1542969,0.4916992-11.8574219,3.3881836
					c-1.0068359,1.0786133-2.5791016,3.3359385-1.8027344,6.3310556l4.8359375,18.6572266L5.3730469,39.251194L0.5371094,20.5934792
					c-1.0917969-4.215332,0.0830078-8.5629892,3.2236328-11.9292002c4.1318359-4.4272461,10.7753906-6.4169922,17.3447266-5.1938477
					L33,5.6857634l11.8945312-2.215332c6.5693359-1.222168,13.2138672,0.7670898,17.3447266,5.1938477
					c3.140625,3.3662109,4.3154297,7.7138681,3.2236328,11.9287119L60.6269531,39.251194z" />
				<path style={style.st72} d="M57.2851181,35.3537331C41.1239853,37.3151588,24.86129,37.3195534,8.6903915,35.3664284
					l-3.3388672-0.4116211v3.3769531l0.9365234,9.0039062l2.3491211,0.3183594
					c7.7207031,1.0039062,15.9714355,1.5053711,24.2595215,1.5053711c8.3261719,0,16.6400146-0.5068359,24.3948975-1.5200195
					l2.2965698-0.3007812l1.0398865-8.4736328l0.0204315-3.9194336L57.2851181,35.3537331z" />
				<rect x="30" y="7.9982634" style={style.st72} width="6" height="30" />
				<circle style={style.st36} cx="47.8118134" cy="42.6655006" r="2.5159504" />
				<circle style={style.st36} cx="18.7640133" cy="42.6655006" r="2.5159504" />
				<circle style={style.st2} cx="6.4971576" cy="41.6232643" r="2.5159504" />
				<circle style={style.st2} cx="33.1627464" cy="43.1726456" r="2.5159504" />
				<circle style={style.st2} cx="59.5028419" cy="41.6232643" r="2.5159504" />
				<path style={style.st2} d="M38.2957001,5.6968212c0-2.9247339-2.3709679-5.2956991-5.2957001-5.2956991
					s-5.2956982,2.370965-5.2956982,5.2956991H38.2957001z" />
				<path style={style.st72} d="M50.293457,39.0851784l-5.8847656-1.1738281l3.7578125-18.8139648
					c0.8740234-3.4213877-0.2597656-4.677247-0.6328125-5.0898447c-2.6425781-2.9257812-10.5595703-2.8144531-13.9804688-2.3032227
					l-0.8857422,0.0332031l-0.2207031-0.0332031c-2.7246094-0.4008789-11.1484375-0.840332-13.9833984,2.3066406
					c-0.3720703,0.4125977-1.5039062,1.6679688-0.6298828,5.0864267l0.0361328,0.15625l3.7216797,18.6577148l-5.8847656,1.1738281
					l-3.7060547-18.5825195c-1.3447266-5.3583994,0.3496094-8.6752939,2.0126953-10.5166025
					C19.2016602,4.238986,30.5649414,5.3991423,33.0004883,5.723361c2.4287109-0.3237305,13.7958984-1.4829102,18.9863281,4.2626953
					c1.6630859,1.8413086,3.3574219,5.1582031,2.0126953,10.5166025L50.293457,39.0851784z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/King.js